import styled from 'styled-components'

export const LogoWrapper = styled.img`
  border-radius: 100%;
  border: 6px solid var(--bg-light);
`
